import React from 'react';
import { AuthContext, AuthContextType } from 'src/contexts/AuthContext';
import { ALSForm } from './ALSForm';
import { useParams } from 'react-router-dom';
import { useGetAlsMemberActivityByCpdIdQuery } from 'src/graphql/generated';
import { Container } from '@mui/material';

export const EditALSForm = () => {
  const { activeMemberId } = React.useContext(AuthContext) as AuthContextType;
  const { activitykey, cpdId } = useParams<{ activitykey?: string; cpdId?: string }>();
  const decodedActivityKey = activitykey ? decodeURIComponent(activitykey) : undefined;
  const decodedCpdID = cpdId ? decodeURIComponent(cpdId) : undefined;
  const getActivityKeyWithCpdId = !decodedActivityKey && !!decodedCpdID;

  const { data, loading, error } = useGetAlsMemberActivityByCpdIdQuery({
    variables: { memberId: activeMemberId, cpdId: decodedCpdID },
    skip: !getActivityKeyWithCpdId
  });

  if (loading) return <Container maxWidth="lg">Loading...</Container>;
  if (error) return <Container maxWidth="lg">Something went wrong, please try again.</Container>;

  const activityKeyFromUrlOrCpdId = data?.getALSMemberActivityByCpdId?.activitykey
    ? data?.getALSMemberActivityByCpdId?.activitykey
    : decodedActivityKey;

  if (!activityKeyFromUrlOrCpdId) {
    return <div>{'No key found'}</div>;
  }

  return <ALSForm activityKeyFromUrlOrCpdId={activityKeyFromUrlOrCpdId} />;
};
